import React, {Component} from 'react'

import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import Proptypes from 'prop-types'

import {colors, CCIcon, CCActions} from './../../cc-imports'
// import './cc-sidebar-layout.css'
import './../../styles/css/layout/CCSideBarLayout/cc-sidebar-layout.css'
class CCSideBarLayout extends Component {

    static propTypes = {
        name: Proptypes.string,
        closeModal: Proptypes.func,
        onBackPress:Proptypes.func
    }

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {}
        this._closeModal = this._closeModal.bind(this);
    }

    _closeModal() {
        if (this.props.closeModal) {
            this.props.closeModal();
            //console.log('aaa')
        }
        else {
            this.props.actions.closeModal(this.props.name,this.props.onBackPress);
            //console.log('bbbb')

        }
    }

    componentDidMount() {
        if (this.props.user.user && this.props.user.user.settings) {
            this.setState(this.props.user.user.settings);
        }
    }


    /*_isOpen(name){
        const modals = this.props.modals.modals;
        var isOpen = false;
        if(modals && modals.length>0){
            isOpen = Platform.OS === 'ios' ? ( modals[modals.length-1].name == name && modals[modals.length-1].active==true ): _.find(modals, {name : name})!=null;
        }
        return isOpen;
    }*/

    _isOpen(name) {
        const modals = this.props.modals.modals;
        var isOpen = false;
        if (modals && modals.length > 0) {
            isOpen = modals[modals.length - 1].name == name;
        }
        if (isOpen) {
            return 'modal-open';
        }
        else
            return 'modal-close';
    }

    render() {
        const {name} = this.props;

        return (
            <div className={"sideBar flex-container " + this._isOpen(name)} style={{ }}>
                <div  style={{backgroundColor: colors.theme2.bg_color2,  height:'100%'}}>
                    <div style={{ elevation: 10, shadowColor: colors.theme2.bg_color2, shadowOffset: {width: 20, height: 20}, shadowOpacity: 1, height:'100%'}}>
                        <div className={'header-parent flex-container side-bar-close'}>
                            <CCIcon onPress={this._closeModal}  className={'cc-close-icon-xs'} type={"sideBarClose"}/>
                        </div>
                        <div className={'flex-container'} style={{flex:1, flexDirection: 'row', height:'100%'}}>
                            {
                                this.props.children
                            }
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(CCSideBarLayout);


// WEBPACK FOOTER //
// ./src/app/layout/CCSideBarLayout/CCSideBarLayout.js